module.exports = __webpack_public_path__ + "static/media/hiw2.91d83521.svg";